export default class BaseEntity {
    id: number = 0
}
